var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6176 18.042C36.7146 18.042 35.5185 18.022 34.0293 18.022C30.3974 18.022 27.4111 15.016 27.4111 11.35V4.918C27.4111 4.412 27.0051 4 26.5061 4H15.9273C10.9903 4 7 8.052 7 13.018V34.568C7 39.778 11.1804 44 16.3392 44H32.0906C37.0117 44 41 39.974 41 35.004V18.942C41 18.434 40.596 18.024 40.093 18.026C39.2494 18.032 38.2335 18.042 37.6176 18.042Z",
    fill: "#CFC8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.1693 5.13462C31.5713 4.51262 30.5273 4.94062 30.5273 5.80262V11.0766C30.5273 13.2886 32.3493 15.1086 34.5593 15.1086C35.9553 15.1246 37.8913 15.1286 39.5353 15.1246C40.3773 15.1226 40.8053 14.1166 40.2213 13.5086C38.1113 11.3146 34.3333 7.38262 32.1693 5.13462Z",
    fill: "#CFC8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2105 25.7674C29.6285 26.3454 28.6865 26.3494 28.1025 25.7634L24.9245 22.5694V32.2234C24.9245 33.0454 24.2565 33.7134 23.4345 33.7134C22.6125 33.7134 21.9465 33.0454 21.9465 32.2234V22.5694L18.7645 25.7634C18.1845 26.3494 17.2405 26.3454 16.6585 25.7674C16.0765 25.1894 16.0745 24.2454 16.6545 23.6614L22.3785 17.9114C22.3805 17.9094 22.3805 17.9094 22.3805 17.9094C22.5165 17.7734 22.6805 17.6634 22.8605 17.5894C23.0405 17.5134 23.2365 17.4734 23.4345 17.4734C23.6345 17.4734 23.8305 17.5134 24.0105 17.5894C24.1885 17.6634 24.3505 17.7734 24.4865 17.9074C24.4885 17.9094 24.4905 17.9094 24.4905 17.9114L30.2145 23.6614C30.7945 24.2454 30.7945 25.1894 30.2105 25.7674Z",
    fill: "#6C5DD3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#6762D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00988 8.87413L5.71305 7.63336L5 8.3156L6.71133 9.95297L6.7133 9.95108L7.02572 10.25L11 6.4455L10.2731 5.75L7.00988 8.87413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSuccess);
export default __webpack_public_path__ + "static/media/upload-success.1129122d240cd7126b5f203f66a34b49.svg";
export { ForwardRef as ReactComponent };